module.exports = __webpack_public_path__ + "static/media/5.d5c1cfe1.jpg";